import { useState } from 'react';
import { message } from 'antd';
import { gql } from 'graphql-tag';
import {
	REVERSE_MAPING_BADGE_TYPE,
	ICON_COMPLETE_MAP,
} from '../../../RnRCommonComponent/CoreBadge/rewardsConstants.js';

const useRewardDetails = (setIsViewRewardModalVisible, currentUser, client) => {
	const [rewardDetails, setRewardDetails] = useState();
	const [isModalLoaderVisible, setIsModalLoaderVisible] = useState(false);
	const GET_BADGE_BY_ID = gql`
		query GetBadgeById($companyId: ID!, $id: ID!) {
			getBadgeById(companyId: $companyId, id: $id) {
				assignmentLevelId
				assignmentLimit
				assignmentSSORequiredId
				automationRule
				badgeTypeId
				badgeType {
					id
					name
					code
					shape {
						id
						name
						shape
					}
				}
				bonusPoints
				category
				color
				createdAt
				companyId
				createdBy
				deletedBy
				deletedAt
				description
				gradientColor
				externalWorkFlowId
				image
				iconId
				icon {
					id
					name
					icon
					iconType
					code
				}
				id
				isPreApproved
				isAssignmentRestricted
				isAssignmentSSORequired
				isRewardRequiresDate
				isRecipientSSORequired
				label
				points
				name
				physicalAwardActivityId
				recipientLevelId
				recipientPayTypeId
				recipientSSORequiredId
				rewardBonus
				rewardMaxBonus
				shape
				badgeRotation
				customImageKey
				customImageSignedUrl
				labelColor
				customIconKey
				customIconSignedUrl
				snappyGrant {
					snappyCampaign {
						name
						companyId
						id
					}
					snappyCampaignTierId
					snappyCampaignId
					pointsRequired
					snappyCampaignId
					description
					name
					costInCurrency
				}
				snappyGrantId
				customShareImages {
					field
					prefix
					url
				}
				updatedAt
				updatedBy
				visibility
				certificateConfig {
					id
					name
					key
				}
			}
		}
	`;
	const handleOpenViewReward = async (
		id,
		completedAt = null,
		badgeAssignment = {}
	) => {
		try {
			setIsViewRewardModalVisible && setIsViewRewardModalVisible(true);
			setIsModalLoaderVisible(true);

			const { data, error } = await client.query({
				query: GET_BADGE_BY_ID,
				variables: {
					companyId: currentUser.companyId,
					id,
				},
				fetchPolicy: 'network-only',
			});

			if (error) {
				console.error('Error fetching badge details:', error);
			}

			if (data?.getBadgeById) {
				const badge = data.getBadgeById;
				const badgeTypeName =
					REVERSE_MAPING_BADGE_TYPE[badge.badgeTypeId] || '';

				let iconInfo = null;
				if (badge.icon) {
					iconInfo = badge.icon;
				} else if (badge.iconId) {
					iconInfo = ICON_COMPLETE_MAP.find((icon) => icon.id === badge.iconId);
				}

				const enrichedDetailedBadge = {
					...badge,
					badgeType: badgeTypeName,
					iconInfo,
					snappyGrantId: badge.snappyGrantId || null,
					earnedDate:
						badgeAssignment?.issuedDate || completedAt || badge.createdAt,
					justificationFormAnswers: badgeAssignment?.justificationFormAnswers,
					isBadgeAssignment: Boolean(badgeAssignment?.id),
					awardedBy:
						badgeAssignment?.awardedBy ??
						badgeAssignment?.rawAssignment?.awardedBy,
					awardedByUser: badgeAssignment?.awardedByUser,
					content: badgeAssignment?.rawAssignment?.content,
					certificateKey:
						badgeAssignment?.rawAssignment?.certificateKey || null,
				};
				setIsModalLoaderVisible(false);
				setRewardDetails(enrichedDetailedBadge);
			}
		} catch (error) {
			setIsModalLoaderVisible(false);
			console.log(error);
			message.error('Failed to fetch recognition details! Try again later.');
		}
	};

	return { rewardDetails, isModalLoaderVisible, handleOpenViewReward };
};

export default useRewardDetails;
